import type { StylePreset } from '@/types';
import { isLocalMode } from '@/local';
import { apiFetch } from './apiBase';
import {
  localCreateStylePreset,
  localDeleteStylePreset,
  localListStylePresets,
} from '@/local/localBackend';

export async function listStylePresets(): Promise<StylePreset[]> {
  if (isLocalMode()) return localListStylePresets();
  const res = await apiFetch('/api/admin/style-presets');
  if (!res.ok) throw new Error(`listStylePresets failed: ${res.status}`);
  return res.json();
}

export async function createStylePreset(
  body: Omit<StylePreset, 'id' | 'isDefault'> & { isDefault?: boolean },
): Promise<StylePreset> {
  if (isLocalMode()) return localCreateStylePreset(body);
  const res = await apiFetch('/api/admin/style-presets', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`createStylePreset failed: ${res.status}`);
  return res.json();
}

/**
 * Promote a preset to the system-wide default. Backend's saving hook
 * automatically demotes any other row that was previously default.
 */
export async function setStylePresetDefault(id: string): Promise<StylePreset> {
  const res = await apiFetch(
    `/api/admin/style-presets/${encodeURIComponent(id)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ isDefault: true }),
    },
  );
  if (!res.ok) throw new Error(`setStylePresetDefault failed: ${res.status}`);
  return res.json();
}

export async function deleteStylePreset(id: string): Promise<void> {
  if (isLocalMode()) return localDeleteStylePreset(id);
  const res = await apiFetch(
    `/api/admin/style-presets/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
  );
  if (!res.ok) throw new Error(`deleteStylePreset failed: ${res.status}`);
}

export async function repointStylePresetModels(): Promise<void> {
  const res = await apiFetch('/api/admin/style-presets/repoint-models', {
    method: 'POST',
  });
  if (!res.ok) throw new Error(`repointStylePresetModels failed: ${res.status}`);
}
